const postComment = async (id, message) => {
  const response = await fetch(`/.netlify/functions/newComment?id=${id}&message=${message.substr(0,240)}`);
  const { data: result, error } = await response.json();
  if (error) {
    throw new Error(error);
  }
  return result;
}


const fetchComments = async (id) => {
    const response = await fetch(`/.netlify/functions/comments?id=${id}`);
    const { data: comments, error } = await response.json();
    if (error) {
      throw new Error(error);
    }
    return comments;
  };

  export default fetchComments
  export {postComment}

  